import { createSlice, UnknownAction } from '@reduxjs/toolkit';
import { isFulfilledAction, isPendingAction, isRejectedAction } from 'app/shared/reducers/reducer.utils';

const initialState = {
  activeRequests: 0,
};

export type LoadingBarState = Readonly<typeof initialState>;

export const LoadingBarSlice = createSlice({
  name: 'loadingBar',
  initialState: initialState as LoadingBarState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addMatcher(isPendingAction, state => {
        state.activeRequests += 1;
      })
      .addMatcher(
        (action: UnknownAction) => isFulfilledAction(action) || isRejectedAction(action),
        state => {
          state.activeRequests = Math.max(0, state.activeRequests - 1);
        },
      );
  },
});

// Reducer
export default LoadingBarSlice.reducer;
